import { __generator } from "tslib";
import { take, put, call, select } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
import { throttle } from 'lodash-es';
import { isImageLoaded, getCurrentScreen, isShowingOverlay, } from '../selectors';
import { mouseMove } from '../actionCreators';
import { getEventMeta } from '../utils/userTest';
function trackMouse() {
    return eventChannel(function (emitter) {
        var throttledEmitter = throttle(emitter, 50);
        window.addEventListener('mousemove', throttledEmitter);
        // The subscriber must return an unsubscribe function
        return function () {
            window.removeEventListener('mousemove', throttledEmitter);
        };
    });
}
export default function saga() {
    var chan, mouseEvent, isRecording, screen_1, isLoaded, overlayShowing, currentState, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(trackMouse)];
            case 1:
                chan = _a.sent();
                _a.label = 2;
            case 2:
                if (!true) return [3 /*break*/, 13];
                return [4 /*yield*/, take(chan)];
            case 3:
                mouseEvent = _a.sent();
                return [4 /*yield*/, select(function (state) { return state.replay.status === 'RECORDING'; })];
            case 4:
                isRecording = _a.sent();
                return [4 /*yield*/, select(getCurrentScreen)];
            case 5:
                screen_1 = _a.sent();
                return [4 /*yield*/, select(isImageLoaded, screen_1.id)];
            case 6:
                isLoaded = _a.sent();
                return [4 /*yield*/, select(isShowingOverlay)];
            case 7:
                overlayShowing = _a.sent();
                if (!(isLoaded && isRecording)) return [3 /*break*/, 12];
                return [4 /*yield*/, select(function (state) { return state; })];
            case 8:
                currentState = _a.sent();
                _a.label = 9;
            case 9:
                _a.trys.push([9, 11, , 12]);
                return [4 /*yield*/, put(mouseMove(getEventMeta(currentState, mouseEvent, {
                        isShowingOverlay: overlayShowing,
                    })))];
            case 10:
                _a.sent();
                return [3 /*break*/, 12];
            case 11:
                err_1 = _a.sent();
                return [3 /*break*/, 12];
            case 12: return [3 /*break*/, 2];
            case 13: return [2 /*return*/];
        }
    });
}
